import React from "react";

// شعارات وسائل الدفع الرسمية — مدى أولاً من جهة اليمين في النسخة العربية (ترتيب DOM = من اليمين في RTL)
const METHODS = [
  { id: "mada", src: "/pay/mada.svg", alt: "مدى mada" },
  { id: "visa", src: "/pay/visa.svg", alt: "Visa" },
  { id: "mastercard", src: "/pay/mastercard.svg", alt: "Mastercard" },
  { id: "applepay", src: "/pay/applepay.svg", alt: "Apple Pay" },
];

export const PaymentMethods = ({ className = "", compact = false }) => (
  <div className={`flex items-center justify-center gap-3 flex-wrap ${className}`} dir="rtl" data-testid="payment-methods">
    {METHODS.map((m) => (
      <span key={m.id} className={`bg-white rounded-lg shadow-sm ring-1 ring-black/5 grid place-items-center ${compact ? "h-8 px-2.5" : "h-11 px-4"}`} data-testid={`payment-logo-${m.id}`}>
        <img src={m.src} alt={m.alt} className={`${compact ? "h-4" : "h-6"} w-auto object-contain`} loading="lazy" />
      </span>
    ))}
  </div>
);
